module.exports = __webpack_public_path__ + "img/france-cardiovascular-diseases-female.227c5b3e.png";